<template>
    <div v-if="tour.awards.length > 0" class="tour-awards d-md-none">
        <div class="awards-container">
            <div v-for="(award, index) in tour.awards" :key="index" class="award-item">
                <span :id="'award-' + index">
                    <img :src="award.image" :alt="award.title" class="award-image">
                </span>
                <BTooltip :target="'award-' + index" triggers="hover" placement="top" custom-class="award-tooltip">
                    {{ award.description }}
                </BTooltip>
            </div>
        </div>
    </div>
</template>

<script>
import { BTooltip } from 'bootstrap-vue'
import FoldSection from "@/components/containers/FoldSection"

export default {
    name: 'TourAwards',
    components: {
        FoldSection,
        BTooltip
    },
    props: {
        tour: {
            type: Object,
            required: true
        }
    },
}
</script>

<style lang="scss" scoped>
.tour-awards {
    display: block;
}

.awards-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    margin: 0px;
    padding: 0px;
}

.award-image {
    max-height: 150px;
}

::v-deep .award-tooltip {
    max-width: 200px;
}
</style>
